import { createSelector } from 'reselect';
import { getActiveSpecId } from './getActiveSpecId';
import { getPacks } from './getPacks';

export const getMappedPacks = createSelector(
	getPacks,
	getActiveSpecId,
	(items, specId) => {
		const mapped = items
			.filter((i) => specId === 0 || i.specId.includes(specId))
			.map((pack) => {
				const plans = [];
				if (pack.priceAll !== null) {
					plans.push({
						label: t('Стоимость'),
						prices: [{ value: pack.priceAllDisplay }],
					});
				} else {
					if (pack.priceBanquetDisplay) {
						plans.push({
							label: pack.priceRentDisplay
								? t('Еда')
								: t('Только еда'),
							prices: [{ value: pack.priceBanquetDisplay }],
						});
					}

					if (pack.priceRentDisplay) {
						plans.push({
							label: pack.priceBanquetDisplay
								? t('Аренда')
								: t('Только аренда'),
							prices: [{ value: pack.priceRentDisplay }],
						});
					}
				}

				return {
					id: pack.id,
					name: pack.name,
					capacity: pack.guests,
					desc: pack.spaces || '-',
					plans,
				};
			});

		return mapped;
	},
);
